module.exports = __webpack_public_path__ + "static/img/single_item_image2.04a345d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/single_item_image2.png
// module id = W++k
// module chunks = 1